import curry from 'lodash/curry';
import { match } from 'spark-util/fpUtils';

export const isObject = maybeObject => typeof maybeObject === 'object';
export const isFileList = value => value instanceof FileList;
export const hasProperty = property => obj => isObject(obj) && obj.hasOwnProperty(property);

export const equalProp = curry(property => a => b => a && b && a[property] === b[property]);

export const pluck = prop => x => isObject(x) && x[prop];
export const valueToObject = property => x => (isObject(x) ? x : { [property]: x });

/**
 * extractProps(['a', 'b'])({ a: 1, b: 2, c: 3})
 * returns { a: 1, b: 2 }
 */
export const extractProps = props => object => {
    return props.reduce((acc, prop) => {
        return (acc[prop] = object[prop]);
    }, {});
};

//Immutably remove a property from an object
export const remove = (key, obj) => {
    const { [key]: _, ...rest } = obj;
    return rest;
};

export const update = (object, key, value) => ({
    ...object,
    [key]: value
});

const objectToBlob = (obj = {}) => new Blob([JSON.stringify(obj)], { type: 'application/json' });

export const asFormData = obj => {
    return Object.entries(obj || {}).reduce((acc, [key, value]) => {
        acc.append(
            key,
            match(value)
                .on(isFileList, fileList => fileList[0])
                .on(isObject, objectToBlob)
                .otherwise(x => x)
        );
        return acc;
    }, new FormData());
};
